// extracted by mini-css-extract-plugin
export default {"loginCard":"Login_loginCard__pepTR","logo":"Login_logo__rK78Y","tagline":"Login_tagline__fov17","brandAcronymTooltip":"Login_brandAcronymTooltip__HcW4F"};